<template>
  <ion-page>
    <CabeceraComponentBackSearch
      :titulo="`Ubicaciones SKU (${clasif})`"
      :showBack="true"
      :pdv="pdv"
      :isIOS="false"
      :placeholder="'Filtrar ubicación...'"
      v-model="filtro"
    />
    <ion-content>
      <div class="container-tablet">
        <ion-list class="ion-no-padding" style="margin:0;">
          <ion-item>
            <ion-label>
              <h2>{{ sku }}</h2>
              <p>{{ nombreDisplay }}</p>
            </ion-label>
          </ion-item>
          <ion-item v-for="u in ubicacionesFiltradas" :key="`ubi:${u.ubicacion}`" button detail @click="goUbicacion(u)">
            <ion-label>
              <div class="ubi">{{ u.ubicacion }}</div>
              <small class="det">Almacén: <b>{{ num(u.stoalm) }}</b> · Contado: <b>{{ num(u.stoman) }}</b></small>
              <div><ion-badge mode="md" color="tertiary" v-if="u.lote && u.lote !== 'N'">Lote: {{ u.lote }}</ion-badge></div>
              <div v-if="u.usr" class="usuario-contado">Contado por: <b>{{ u.usrName || u.usr }}</b></div>
            </ion-label>
            <ion-badge v-if="u.is_primaria === 1" color="success">Primaria</ion-badge>
          </ion-item>
          <ion-item v-if="ubicaciones.length === 0 && !cargando">
            <ion-label>
              <p>No hay ubicaciones para este SKU en el inventario</p>
            </ion-label>
          </ion-item>
          <ion-item v-if="cargando">
            <ion-spinner></ion-spinner>
          </ion-item>
        </ion-list>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue'
import { openToast } from '@/utilities/services/alert-utilities'
import CabeceraComponentBackSearch from '@/components/CabeceraComponentBackSearch.vue'

export default defineComponent({
  name: 'InventarioSkuUbicacionesPage',
  components: { CabeceraComponentBackSearch },
  props: {
    pdv: { type: String, required: true },
    fecinv: { type: [String, Number], required: true },
    clasif: { type: String, default: '00' },
    sku: { type: String, required: true }
  },
  data () {
    return {
      ubicaciones: [],
      cargando: true,
      filtro: ''
    }
  },
  computed: {
    nombreDisplay () {
      return this.$route.query.nombre || ''
    },
    ubicacionesFiltradas () {
      if (!this.filtro) return this.ubicaciones
      const f = this.filtro.toUpperCase()
      return this.ubicaciones.filter(u => u.ubicacion.toUpperCase().includes(f))
    }
  },
  async mounted () {
    await this.cargar()
  },
  methods: {
    num (n) { try { return Number(n || 0).toLocaleString('es-ES') } catch { return String(n || 0) } },
    async cargar () {
      this.cargando = true
      try {
        const url = `/inventario_sku_ubicaciones/${this.pdv}/${this.fecinv}/${this.clasif}/${encodeURIComponent(this.sku)}`
        const res = await this.$http.get(url)
        const arr = Array.isArray(res.data) ? res.data : []
        this.ubicaciones = arr.map(x => ({
          ubicacion: String(x.ubicacion || x.UBICACION || ''),
          stoalm: Number(x.stoalm || x.STOALM || 0),
          stoman: Number(x.stoman || x.STOMAN || 0),
          is_primaria: Number(x.is_primaria || x.IS_PRIMARIA || 0),
          lote: String((x.lote ?? x.numlot ?? x.LOTE ?? x.NUMLOT ?? 'N') || 'N'),
          usr: x.usr || null,
          usrName: x.usrName || null
        }))
      } catch (ex) {
        this.ubicaciones = []
        console.error(ex)
      } finally {
        this.cargando = false
      }
    },
    obtenerBloqueante (ubi, info) {
      const local = ubi && typeof ubi === 'object' ? (ubi.blqUsr || null) : null
      const remoto = info && typeof info === 'object' ? (info.blqUsr || null) : null
      return remoto || local || null
    },
    async goUbicacion (ubi) {
      const ubic = typeof ubi === 'string' ? ubi : ubi.ubicacion
      
      try {
        const res = await this.$http.get(`/inventario_ubicacion/${this.pdv}/${this.fecinv}/${this.clasif}/${ubic}`)
        const info = Array.isArray(res.data) ? (res.data[0] || {}) : (res.data || {})
        
        const bloqueante = this.obtenerBloqueante(ubi, info)
        if (bloqueante) {
          openToast(`Ubicación bloqueada por ${bloqueante}`)
          return
        }
      } catch (ex) {
        console.log('No se pudo verificar bloqueo antes de navegar', ex)
      }

      this.$router.push({ name: 'inventario_ubicacion', params: { pdv: this.pdv, fecinv: this.fecinv, clasif: this.clasif, ubi: ubic } })
    }
  }
})
</script>

<style scoped>
.ubi { font-weight: bold; }
.det { color: var(--ion-color-medium); }
.usuario-contado { color: var(--ion-color-primary); font-size: 0.85rem; margin-top: 2px; }
.container-tablet { width: 100%; max-width: 768px; margin: 0 auto; scrollbar-width: none; }
</style>
